import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function useScrollMemory() {
  const location = useLocation();

  useEffect(() => {
    const key = `scroll-${location.pathname}`;

    // Restore scroll
    const saved = sessionStorage.getItem(key);
    if (saved) {
      window.scrollTo(0, parseInt(saved, 10));
    }

    // Save scroll before unmount
    return () => {
      sessionStorage.setItem(key, window.scrollY);
    };
  }, [location]);
}
